<script setup>
/**
 * Campana de notificaciones (Masifi) — trigger del Popover en el sidebar.
 * Presentación propia (rebase-safe); consume SOLO la capa de datos nativa
 * (store notifications/getMeta), no el componente upstream incompleto
 * SidebarNotificationBell.vue. El badge se mantiene vivo por websocket.
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

defineProps({
  // Alturas parejas con la fila superior del sidebar: 28px expandida
  // (como búsqueda/redactar), 32px colapsada (como los íconos apilados).
  isCollapsed: { type: Boolean, default: false },
});

const { t } = useI18n();
const meta = useMapGetter('notifications/getMeta');

const unreadLabel = computed(() => {
  const count = meta.value.unreadCount || 0;
  if (!count) return '';
  return count < 100 ? `${count}` : '99+';
});
</script>

<template>
  <button
    type="button"
    :aria-label="t('NOTIFICATION_PANEL.HEADER')"
    class="relative grid flex-shrink-0 rounded-lg place-content-center text-n-slate-11 outline outline-1 outline-n-weak bg-n-button-color hover:bg-n-alpha-2 dark:hover:bg-n-slate-9/30 transition-all duration-100 ease-out"
    :class="isCollapsed ? 'size-8' : 'size-7'"
  >
    <span class="i-lucide-bell size-4" />
    <span
      v-if="unreadLabel"
      class="absolute -top-1 grid min-w-2 px-1 py-0.5 text-[9px] leading-none rounded-lg min-h-2 ltr:-right-1.5 rtl:-left-1.5 place-items-center bg-n-ruby-9 text-n-ruby-3"
    >
      {{ unreadLabel }}
    </span>
  </button>
</template>
